// import { useProductFeature } from '@src/pages/[...slug]/components/product/productFeatureProvider'

import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'
import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-locale-config.hook'

export const useNewPdpDesignV2Bucket = () => {
  const { pdpDesignV2Enabled = false } = useStatsigDynamicLocaleConfig()
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.NEW_PDP_DESIGN_V2)
  return pdpDesignV2Enabled ? experimentBucket : STATSIG_EXPERIMENTS_BUCKETS.CONTROL
}
